import { TypedDocumentNode, gql } from '@apollo/client';

import useQuery from '@sorare/core/src/hooks/graphql/useQuery';

import {
  CurrentUserPurchasesQuery,
  CurrentUserPurchasesQueryVariables,
} from './__generated__/useGetCurrentUserPurchases.graphql';

export const CURRENT_USER_PURCHASES = gql`
  query CurrentUserPurchasesQuery {
    currentUser {
      slug
      wonTokenAuctions(first: 1, sport: FOOTBALL) {
        totalCount
      }
      boughtSingleSaleTokenOffers(first: 1) {
        totalCount
      }
    }
  }
` as TypedDocumentNode<
  CurrentUserPurchasesQuery,
  CurrentUserPurchasesQueryVariables
>;

const useGetCurrentUserPurchases = ({ skip }: { skip?: boolean }) => {
  return useQuery(CURRENT_USER_PURCHASES, { skip });
};

export default useGetCurrentUserPurchases;
